var _defs, _rect, _rect2, _rect3, _text, _rect4, _text2, _rect5, _text3, _rect6, _text4, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProductDashboardWeb(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1400,
    height: 800,
    viewBox: "0 0 1400 800",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "gGreen",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#4CAF50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#2E7D32"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gBlue",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#2196F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#1565C0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gOrange",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFC107"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FF6F00"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "shadow",
    x: "-20%",
    y: "-20%",
    width: "140%",
    height: "140%"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 0,
    dy: 10,
    stdDeviation: 12,
    floodColor: "#0B1220",
    floodOpacity: 0.12
  })), /*#__PURE__*/React.createElement("style", null, "\r\n      .bg { fill: #F8FAFC; }\r\n      .panel { fill: #FFFFFF; stroke: rgba(15,23,42,0.08); filter: url(#shadow); }\r\n      .muted { fill: #4A5568; font-family: Inter, Roboto, Arial, sans-serif; }\r\n      .title { fill: #1A202C; font-family: Inter, Roboto, Arial, sans-serif; font-weight: 700; }\r\n      .label { fill: #1A202C; font-family: Inter, Roboto, Arial, sans-serif; font-weight: 600; }\r\n      .chip { fill: rgba(76,175,80,0.12); stroke: rgba(76,175,80,0.20); }\r\n      .chipTxt { fill: #2E7D32; font-family: Inter, Roboto, Arial, sans-serif; font-weight: 600; }\r\n      .nav { fill: #FFFFFF; stroke: rgba(15,23,42,0.08); }\r\n      .navItem { fill: #334155; font-family: Inter, Roboto, Arial, sans-serif; font-size: 14px; }\r\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "bg",
    x: 0,
    y: 0,
    width: 1400,
    height: 800
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "nav",
    x: 40,
    y: 30,
    width: 1320,
    height: 64,
    rx: 18,
    filter: "url(#shadow)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 62,
    y: 48,
    width: 34,
    height: 34,
    rx: 10,
    fill: "url(#gGreen)"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "title",
    x: 110,
    y: 72,
    fontSize: 20
  }, "Carbon Intelligence")), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 1070,
    y: 48,
    width: 120,
    height: 34,
    rx: 17,
    fill: "rgba(33,150,243,0.10)",
    stroke: "rgba(33,150,243,0.20)"
  })), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    className: "muted",
    x: 1090,
    y: 70,
    fontSize: 14
  }, "MSME")), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 1210,
    y: 48,
    width: 130,
    height: 34,
    rx: 17,
    fill: "url(#gBlue)"
  })), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 1240,
    y: 71,
    fontSize: 14,
    fill: "#FFFFFF",
    fontFamily: "Inter, Roboto, Arial, sans-serif",
    fontWeight: 600
  }, "Export report")), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "nav",
    x: 40,
    y: 112,
    width: 260,
    height: 658,
    rx: 22,
    filter: "url(#shadow)"
  })), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    className: "label",
    x: 70,
    y: 155,
    fontSize: 14
  }, "Navigation")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 175,
    width: 220,
    height: 44,
    rx: 14,
    fill: "rgba(76,175,80,0.10)",
    stroke: "rgba(76,175,80,0.20)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "navItem",
    x: 85,
    y: 203,
    fontWeight: 700,
    fill: "#2E7D32"
  }, "Dashboard"), /*#__PURE__*/React.createElement("text", {
    className: "navItem",
    x: 85,
    y: 255
  }, "Carbon Footprint"), /*#__PURE__*/React.createElement("text", {
    className: "navItem",
    x: 85,
    y: 303
  }, "Recommendations"), /*#__PURE__*/React.createElement("text", {
    className: "navItem",
    x: 85,
    y: 351
  }, "Reporting"), /*#__PURE__*/React.createElement("text", {
    className: "navItem",
    x: 85,
    y: 399
  }, "Document Management"), /*#__PURE__*/React.createElement("text", {
    className: "navItem",
    x: 85,
    y: 447
  }, "Green Loans"))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(320,112)"
  }, /*#__PURE__*/React.createElement("text", {
    className: "title",
    x: 10,
    y: 48,
    fontSize: 34,
    fill: "url(#gGreen)"
  }, "Dashboard"), /*#__PURE__*/React.createElement("text", {
    className: "muted",
    x: 12,
    y: 78,
    fontSize: 16
  }, "Welcome back, ", /*#__PURE__*/React.createElement("tspan", {
    fontWeight: 700,
    fill: "#1A202C"
  }, "Your MSME"), ". Here's your carbon footprint overview."), /*#__PURE__*/React.createElement("g", {
    transform: "translate(10,110)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "panel",
    x: 0,
    y: 0,
    width: 280,
    height: 110,
    rx: 20
  }), /*#__PURE__*/React.createElement("text", {
    className: "label",
    x: 22,
    y: 36,
    fontSize: 14
  }, "Carbon score"), /*#__PURE__*/React.createElement("text", {
    className: "title",
    x: 22,
    y: 78,
    fontSize: 36
  }, "84"), /*#__PURE__*/React.createElement("rect", {
    className: "chip",
    x: 88,
    y: 54,
    width: 90,
    height: 26,
    rx: 13
  }), /*#__PURE__*/React.createElement("text", {
    className: "chipTxt",
    x: 104,
    y: 73,
    fontSize: 12
  }, "Excellent")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(310,110)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "panel",
    x: 0,
    y: 0,
    width: 280,
    height: 110,
    rx: 20
  }), /*#__PURE__*/React.createElement("text", {
    className: "label",
    x: 22,
    y: 36,
    fontSize: 14
  }, "CO\u2082 saved"), /*#__PURE__*/React.createElement("text", {
    className: "title",
    x: 22,
    y: 78,
    fontSize: 34,
    fill: "#2E7D32"
  }, "150 kg"), /*#__PURE__*/React.createElement("rect", {
    x: 180,
    y: 20,
    width: 80,
    height: 80,
    rx: 18,
    fill: "rgba(76,175,80,0.08)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220 40 C205 58, 210 85, 230 85 C250 85, 255 58, 240 40 C234 32, 226 32, 220 40 Z",
    fill: "url(#gGreen)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(610,110)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "panel",
    x: 0,
    y: 0,
    width: 280,
    height: 110,
    rx: 20
  }), /*#__PURE__*/React.createElement("text", {
    className: "label",
    x: 22,
    y: 36,
    fontSize: 14
  }, "Cost savings"), /*#__PURE__*/React.createElement("text", {
    className: "title",
    x: 22,
    y: 78,
    fontSize: 34
  }, "\u20B9 7,500"), /*#__PURE__*/React.createElement("rect", {
    x: 180,
    y: 20,
    width: 80,
    height: 80,
    rx: 18,
    fill: "rgba(33,150,243,0.08)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214 74 L226 36 L238 74 Z",
    fill: "url(#gBlue)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 212,
    y: 74,
    width: 28,
    height: 6,
    rx: 3,
    fill: "rgba(26,32,44,0.20)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(910,110)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "panel",
    x: 0,
    y: 0,
    width: 280,
    height: 110,
    rx: 20
  }), /*#__PURE__*/React.createElement("text", {
    className: "label",
    x: 22,
    y: 36,
    fontSize: 14
  }, "Next milestone"), /*#__PURE__*/React.createElement("text", {
    className: "title",
    x: 22,
    y: 74,
    fontSize: 22
  }, "30% reduction"), /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 86,
    width: 236,
    height: 10,
    rx: 5,
    fill: "#E2E8F0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 86,
    width: 170,
    height: 10,
    rx: 5,
    fill: "url(#gOrange)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(10,250)"
  }, /*#__PURE__*/React.createElement("text", {
    className: "label",
    x: 0,
    y: 22,
    fontSize: 16
  }, "Quick actions"), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,40)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "panel",
    x: 0,
    y: 0,
    width: 280,
    height: 160,
    rx: 22
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 22,
    width: 236,
    height: 42,
    rx: 14,
    fill: "rgba(33,150,243,0.10)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "label",
    x: 38,
    y: 48,
    fontSize: 14
  }, "Carbon Assessment"), /*#__PURE__*/React.createElement("text", {
    className: "muted",
    x: 22,
    y: 96,
    fontSize: 13
  }, "Guided wizard across energy, waste,"), /*#__PURE__*/React.createElement("text", {
    className: "muted",
    x: 22,
    y: 116,
    fontSize: 13
  }, "transport, materials, and ESG scopes."), /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 126,
    width: 236,
    height: 36,
    rx: 12,
    fill: "url(#gBlue)"
  }), /*#__PURE__*/React.createElement("text", {
    x: 96,
    y: 150,
    fontSize: 13,
    fill: "#FFFFFF",
    fontFamily: "Inter, Roboto, Arial, sans-serif",
    fontWeight: 600
  }, "Start assessment")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(300,40)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "panel",
    x: 0,
    y: 0,
    width: 280,
    height: 160,
    rx: 22
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 22,
    width: 236,
    height: 42,
    rx: 14,
    fill: "rgba(76,175,80,0.10)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "label",
    x: 38,
    y: 48,
    fontSize: 14
  }, "Recommendations"), /*#__PURE__*/React.createElement("text", {
    className: "muted",
    x: 22,
    y: 96,
    fontSize: 13
  }, "Prioritized actions with savings,"), /*#__PURE__*/React.createElement("text", {
    className: "muted",
    x: 22,
    y: 116,
    fontSize: 13
  }, "CO\u2082 reduction, and payback period."), /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 126,
    width: 236,
    height: 36,
    rx: 12,
    fill: "url(#gGreen)"
  }), /*#__PURE__*/React.createElement("text", {
    x: 92,
    y: 150,
    fontSize: 13,
    fill: "#FFFFFF",
    fontFamily: "Inter, Roboto, Arial, sans-serif",
    fontWeight: 600
  }, "View actions")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(600,40)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "panel",
    x: 0,
    y: 0,
    width: 280,
    height: 160,
    rx: 22
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 22,
    width: 236,
    height: 42,
    rx: 14,
    fill: "rgba(255,193,7,0.18)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "label",
    x: 38,
    y: 48,
    fontSize: 14
  }, "Green Loans"), /*#__PURE__*/React.createElement("text", {
    className: "muted",
    x: 22,
    y: 96,
    fontSize: 13
  }, "Eligibility check, rate discounts"), /*#__PURE__*/React.createElement("text", {
    className: "muted",
    x: 22,
    y: 116,
    fontSize: 13
  }, "based on carbon score &amp; savings."), /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 126,
    width: 236,
    height: 36,
    rx: 12,
    fill: "url(#gOrange)"
  }), /*#__PURE__*/React.createElement("text", {
    x: 92,
    y: 150,
    fontSize: 13,
    fill: "#1A202C",
    fontFamily: "Inter, Roboto, Arial, sans-serif",
    fontWeight: 700
  }, "Apply now")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(900,40)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "panel",
    x: 0,
    y: 0,
    width: 280,
    height: 160,
    rx: 22
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 22,
    width: 236,
    height: 42,
    rx: 14,
    fill: "rgba(76,175,80,0.08)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "label",
    x: 38,
    y: 48,
    fontSize: 14
  }, "Documents"), /*#__PURE__*/React.createElement("text", {
    className: "muted",
    x: 22,
    y: 96,
    fontSize: 13
  }, "Upload bills/invoices, auto-extract"), /*#__PURE__*/React.createElement("text", {
    className: "muted",
    x: 22,
    y: 116,
    fontSize: 13
  }, "data, detect duplicates, compute CO\u2082."), /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 126,
    width: 236,
    height: 36,
    rx: 12,
    fill: "#FFFFFF",
    stroke: "rgba(33,150,243,0.35)"
  }), /*#__PURE__*/React.createElement("text", {
    x: 90,
    y: 150,
    fontSize: 13,
    fill: "#1565C0",
    fontFamily: "Inter, Roboto, Arial, sans-serif",
    fontWeight: 700
  }, "Manage files"))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductDashboardWeb);
export default __webpack_public_path__ + "static/media/product-dashboard-web.33c00285b15bb75c07f26931ed666218.svg";
export { ForwardRef as ReactComponent };